import React, { createContext, ReactNode, useEffect, useState } from 'react';

import { debounce } from 'lodash';

import theme from '@/theme';

type Ctx = {
  width: number;
  height: number;
  isLandscape: boolean;
  isPhone: boolean;
  isDesktop: boolean;
}

export const WindowDimensionsContext = createContext<Ctx>({} as Ctx);

type Props = {
  children: ReactNode;
}

export function WindowDimensionsProvider({ children }: Props) {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    const debouncedResize = debounce(handleResize, 800);
    window.addEventListener('resize', debouncedResize);
    return () => window.removeEventListener('resize', debouncedResize);
  }, []);

  return (
    <WindowDimensionsContext.Provider
      value={{...windowDimensions}}
    >
      { children }
    </WindowDimensionsContext.Provider>
  );
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
    isLandscape: width > height,
    isPhone: width < theme.breakpoints.md,
    isDesktop: width >= theme.breakpoints.lg,
  };
}
